import React, { useState } from 'react';
import { Menu, X, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';

const WHATSAPP_NUMBER = '556296481343'; // Substitua pelo número real

const Header = ({ onOpenOrder }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const openWhatsApp = () => {
    const message = encodeURIComponent('Olá! Vim do site da FEATS e gostaria de saber mais sobre o serviço.');
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, '_blank');
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <button
            type="button"
            onClick={() => scrollToSection('home')}
            className="flex-shrink-0 flex items-center gap-2 focus:outline-none"
          >
            <img
              src="/logo.png"
              alt="FEATS"
              className="h-10 w-auto"
            />
            <h1 className="text-2xl font-bold text-orange-600">FEATS</h1>
          </button>

          <nav className="hidden md:flex space-x-8">
            <button onClick={() => scrollToSection('como-funciona')} className="text-gray-700 hover:text-orange-600 transition-colors">
              Como Funciona
            </button>
            <button onClick={() => scrollToSection('cardapio')} className="text-gray-700 hover:text-orange-600 transition-colors">
              Cardápio
            </button>
            <button onClick={() => scrollToSection('planos')} className="text-gray-700 hover:text-orange-600 transition-colors">
              Planos
            </button>
            <button onClick={() => scrollToSection('faq')} className="text-gray-700 hover:text-orange-600 transition-colors">
              FAQ
            </button>
          </nav>

          <div className="hidden md:flex items-center space-x-4">
            <Button variant="outline" onClick={openWhatsApp} className="border-green-600 text-green-600 hover:bg-green-50">
              <MessageCircle className="mr-2 h-4 w-4" />
              WhatsApp
            </Button>
            <Button onClick={onOpenOrder} className="bg-orange-600 hover:bg-orange-700">
              Montar Pedido
            </Button>
          </div>

          <button
            className="md:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-4 pt-2 pb-4 space-y-2">
            <button onClick={() => scrollToSection('como-funciona')} className="block w-full text-left px-3 py-2 text-gray-700 hover:bg-gray-100 rounded">
              Como Funciona
            </button>
            <button onClick={() => scrollToSection('cardapio')} className="block w-full text-left px-3 py-2 text-gray-700 hover:bg-gray-100 rounded">
              Cardápio
            </button>
            <button onClick={() => scrollToSection('planos')} className="block w-full text-left px-3 py-2 text-gray-700 hover:bg-gray-100 rounded">
              Planos
            </button>
            <button onClick={() => scrollToSection('faq')} className="block w-full text-left px-3 py-2 text-gray-700 hover:bg-gray-100 rounded">
              FAQ
            </button>
            <div className="pt-2 space-y-2">
              <Button variant="outline" onClick={openWhatsApp} className="w-full border-green-600 text-green-600 hover:bg-green-50">
                <MessageCircle className="mr-2 h-4 w-4" />
                WhatsApp
              </Button>
              <Button onClick={onOpenOrder} className="w-full bg-orange-600 hover:bg-orange-700">
                Montar Pedido
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
